import React, { Component } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import {
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    ZAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';

const dataOther = [
    { x: 22, y: 0.003, z: 10 },
    { x: 24, y: 0.004, z: 200 },    
    { x: 29, y: 0.0065, z: 10 },
    { x: 38, y: 0.007, z: 10 },    
    { x: 40, y: 0.024, z: 10 },
    { x: 50, y: 0.056, z: 10 },
];
const dataInsulation = [
    { x: 26, y: 0.002, z: 10 },
    { x: 28, y: 0.0025, z: 10 },
    { x: 31, y: 0.003, z: 10 },
    { x: 32, y: 0.004, z: 10 },
    { x: 34, y: 0.0045, z: 10 },
    { x: 36, y: 0.005, z: 10 },
    { x: 39, y: 0.006, z: 10 },
    { x: 40, y: 0.007, z: 10 },
    { x: 42, y: 0.009, z: 10 },
    { x: 44, y: 0.01, z: 10 },
    { x: 45, y: 0.012, z: 10 },
    { x: 46, y: 0.018, z: 10 },
    { x: 46, y: 0.020, z: 10 },
    { x: 48, y: 0.025, z: 10 },
    { x: 48, y: 0.030, z: 10 },
    { x: 49, y: 0.040, z: 10 },
    { x: 51, y: 0.045, z: 10 },
];

const dataOLTC = [
    { x: 13, y: 0.0015, z: 10 },
    { x: 14, y: 0.002, z: 10 },
    { x: 17, y: 0.003, z: 10 },
    { x: 22, y: 0.0035, z: 10 },
    { x: 28, y: 0.004, z: 10 },
    { x: 31, y: 0.0045, z: 10 },
    { x: 35, y: 0.005, z: 10 },
    { x: 35, y: 0.0055, z: 10 },
    { x: 37, y: 0.006, z: 10 },
    { x: 45, y: 0.0095, z: 10 },
    { x: 49, y: 0.02, z: 10 },
    { x: 54, y: 0.03, z: 10 },
];

const dataWindings = [
    { x: 11, y: 0.003, z: 10 },
    { x: 12, y: 0.0035, z: 10 },
    { x: 14, y: 0.004, z: 200 },
    { x: 15, y: 0.0045, z: 10 },
    { x: 16, y: 0.005, z: 10 },
    { x: 16.5, y: 0.0055, z: 10 },
    { x: 17, y: 0.006, z: 10 },
    { x: 18, y: 0.0065, z: 10 },
    { x: 20, y: 0.007, z: 10 },
    { x: 22, y: 0.0075, z: 10 },
    { x: 24, y: 0.008, z: 10 },
    { x: 25, y: 0.0085, z: 10 },
    { x: 28, y: 0.009, z: 10 },
    { x: 30, y: 0.009, z: 10 },
    { x: 32, y: 0.01, z: 10 },
    { x: 34, y: 0.012, z: 10 },
    { x: 35, y: 0.016, z: 10 },
    { x: 36, y: 0.018, z: 10 },
    { x: 38, y: 0.02, z: 10 },
    { x: 39, y: 0.022, z: 10 },
    { x: 40, y: 0.024, z: 10 },
    { x: 41, y: 0.026, z: 10 },
    { x: 41, y: 0.028, z: 10 },
    { x: 42, y: 0.032, z: 10 },
    { x: 43, y: 0.035, z: 10 },
    { x: 45, y: 0.039, z: 10 },
    { x: 45, y: 0.040, z: 10 },
    { x: 45, y: 0.042, z: 10 },
    { x: 46, y: 0.045, z: 10 },
    { x: 50, y: 0.050, z: 10 },
    { x: 50, y: 0.056, z: 10 },
    { x: 50, y: 0.058, z: 10 },
];

const dataBushing = [
    { x: 11, y: 0.002, z: 10 },
    { x: 12, y: 0.0025, z: 10 },
    { x: 15, y: 0.003, z: 10 },
    { x: 17, y: 0.0035, z: 10 },
    { x: 22, y: 0.004, z: 10 },
    { x: 25, y: 0.0045, z: 10 },
];

const dataUnknown = [
    { x: 11, y: 0.002, z: 10 },
    { x: 12, y: 0.0025, z: 10 },
    { x: 15, y: 0.003, z: 10 },
    { x: 17, y: 0.0035, z: 10 },
    { x: 22, y: 0.004, z: 10 },
    { x: 25, y: 0.0045, z: 10 },
];


export class WeibullChart extends Component {

    render() {
        return (
            <>
                <ScatterChart
                    width={600}
                    height={400}
                    margin={{
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 20,
                    }}
                >
                    <CartesianGrid />
                    <XAxis type="number" dataKey="x" name="age" unit="" />
                    <YAxis type="number" dataKey="y" name="weibull cdf" unit="" />
                    {/* <ZAxis type="number" dataKey="z" range={[60, 400]} name="score" unit="km" /> */}                    
                    <Tooltip cursor={{ strokeDasharray: '3 3' }} />
                    <Legend />
                    <Scatter name="Other" data={dataOther} fill="#1580eb" shape="cross"/>
                    <Scatter name="Insulation" data={dataInsulation} fill="#11b891" shape="circle" />
                    <Scatter name="OLTC" data={dataOLTC} fill="#cadb0d" shape="square" />
                    <Scatter name="Winding" data={dataWindings} fill="#eda724" shape="triangle" />
                    <Scatter name="Bushing" data={dataBushing} fill="#ba2d11" shape="circle" />
                    <Scatter name="Unknown" data={dataUnknown} fill="#19c9fa" shape="circle" />

                    {/* <Scatter name="Other" data={data01} fill="#82ca9d" shape={CloseIcon}/> */}
                </ScatterChart>
            </>
        );
    }
}

export default WeibullChart;

